import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import addInsegnante from "../../services/addInsegnante";
import FixButton from "../../widgets/Button";
import Utils from "../../utils/utils";
import addUtente from "../../services/addUtente";
import addMateria from "../../services/addMateria";

export default class AddMateria extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			materia: "",
			note: "",
		};

		this.pageTitle = "Aggiungi Materia";
	}

	lockedSaveMateria = Utils.disallowConcurrency(this.save.bind(this));

	render() {
		return (
			<>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle title={this.pageTitle} />
					<TextInput
						name={"Materia"}
						value={this.state.materia}
						onChange={text => {
							this.setState({ materia: text });
						}}
					/>
					<TextInput
						name={"Note"}
						value={this.state.note}
						onChange={text => {
							this.setState({ note: text });
						}}
					/>
					<br />
					<FixButton title={"Salva"} callback={this.state.isLoading ? () => {} : this.lockedSaveMateria} />
					<br />
					<br />
					<br />
					<br />
					<br />
					<br />
				</LoadingOverlay>
			</>
		);
	}

	async save() {
		if (this.state.materia.trim() !== "") {
			this.setState({ isLoading: true });
			const cookies = new Cookies();
			const token = cookies.get("token", { path: "/" });
			const username = cookies.get("username", { path: "/" });

			let ret = await addMateria(username, token, this.state.materia, this.state.note);

			console.log(ret);

			if (ret.result === "ok") {
				this.setState({ isLoading: false });
				window.location.href = "/#/app/materie";
			} else {
				this.setState({ isLoading: false });
				alert("Si è verificato un errore durante la creazione della nuova materia. Per favore, riprova.");
			}
		} else {
			alert("Inserisci il nome della materia prima di salvare.");
		}
	}
}
